import ErrorPage from "../components/molecules/errorPage/errorPage";

export default function Custom500() {
    return <ErrorPage statusCode={500} message="Internal server error."/>
  }